import { ISelectData } from 'components/atoms/SelectComponent';

import { ETypPrahu } from 'services/korporatniAkce/pruvodceVH';

export const prahSelect: ISelectData[] = [
    {
        labelcz: 'SRD_PRUVODCE_VH_E_PRAH_ALSH',
        value: ETypPrahu.ALSH
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_E_PRAH_ALSM',
        value: ETypPrahu.ALSM
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_E_PRAH_ALVO',
        value: ETypPrahu.ALVO
    }
];
